const namespace = "subject";

export const subject = `${namespace}_category_list`;
export const subject_select = `${namespace}_category_select`;

export const topic_select = `${namespace}_topic_select`;
